import { ActiveFilter, Stack } from '@eleveo/components-react';
import { equals } from 'ramda';
import React from 'react';
import { AnyObject } from 'react-final-form';

type FilterConfigType<FilterName> = {
  dataTestId?: string;
  id: string;
  key: FilterName;
  name: string;
  defaultValue?: any;
  value: string;
};

type ActiveFiltersProps<FilterType, FilterName> = {
  config: FilterConfigType<FilterName>[];
  cancelFilterSidebar: () => void;
  openFilterSidebarItem: (itemId: string) => void;
  setSidebarFilter: (sidebarFilter: FilterType) => void;
  sidebarFilter: FilterType;
};

export function ActiveFilters<
  StateType extends AnyObject,
  FilterType extends Record<string, StateType>,
  FilterName extends keyof FilterType
>(props: ActiveFiltersProps<FilterType, FilterName>) {
  const { config, cancelFilterSidebar, openFilterSidebarItem, setSidebarFilter, sidebarFilter } = props;

  const handleRemoveFilter = (filterKey: FilterConfigType<FilterName>['key'], defaultValue: StateType) => {
    cancelFilterSidebar();

    setSidebarFilter({
      ...sidebarFilter,
      [filterKey]: defaultValue,
    });
  };

  const filters = config
    .filter(({ key, defaultValue }) => !equals(sidebarFilter[key], defaultValue))
    .map(({ id, key, name, dataTestId, defaultValue, value }) => (
      <ActiveFilter
        key={id}
        name={name}
        onClick={() => openFilterSidebarItem(id)}
        onRemove={() => handleRemoveFilter(key, defaultValue)}
        testId={dataTestId}
        value={value}
      />
    ));

  if (!filters.length) {
    return null;
  }

  return (
    <Stack direction="horizontal" className="flex-wrap items-center" spacing={15}>
      {filters}
    </Stack>
  );
}
